import { Navigate, Route, Routes } from "react-router-dom";
import { Dashboard } from "./screens/dashboard/Dashboard";
import { Error404 } from "./screens/404/Error404";
import { Licenses } from "./screens/licenses/Licenses";
import { ManageSuppliers } from "./screens/supplier/ManageSuppliers";

import { UrlForward } from "./screens/urlforward/UrlForward";
import { ReportsDownloadBilling } from "./screens/reports/ReportsDownloadBilling";
import { Products } from "./screens/products/Products";
import { LocaleStrings } from "./screens/localestrings/LocaleStrings";
import { Downloads } from "./screens/downloads/Downloads";
import { EmailHistory } from "./screens/emailhistory/EmailHistory";
import { Users } from "./screens/users/Users";
import { UserDetails } from "./screens/users/UserDetails";
import { ManageSupplierProducts } from "./screens/supplierproducts/ManageSupplierProducts";
import { LicenseDetails } from "./screens/licenses/LicenseDetails";
import LicenseManager from "./screens/licensemanager/LicenseManager";
import { Logs } from "./screens/logs/Logs";
import { ManageHoops } from "./screens/hoops/ManageHoops";
import { UpdateHoop } from "./screens/hoops/UpdateHoop";
import { Payments } from "./screens/reports/Payments";
import { MachineLicenses } from "./screens/licenses/MachineLicenses";
import { Summit } from "./screens/summit/Summit";
// import { SummitDetails } from "./screens/summit/SummitDetails";
import { ManageThreads } from "./screens/threads/ManageThreads";
import { UpdateThread } from "./screens/threads/UpdateThread";
import { DigitizingOrdersLogs } from "./screens/digitizingorderslogs/DigitizingOrdersLogs";
import { Coupons } from "./screens/coupons/Coupons";
// import { ManageHoops } from "./screens/hoops/ManageHoops";
// import { UpdateHoop } from "./screens/hoops/UpdateHoop";

export const MainContentControlCenter: React.FC = () => {
  return (
    <Routes>
      <Route path="/">
        <Route path="" element={<Navigate to="dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Route>
      {/* <Route path="/users" element={<Users />} />  */}
      <Route path="users">
        <Route path="" element={<Users />} />
        <Route path=":userId" element={<UserDetails />} />
      </Route>

      {/* <Route path="licenses">
        <Route path="" element={<Licenses />} />
        <Route path=":licenseId" element={<LicenseDetails />} />
      </Route> */}

      <Route path="licenses">
        <Route path="/licenses/softwarelicenses" element={<Licenses />} />
        <Route path="/licenses/softwarelicenses/:licenseId" element={<LicenseDetails />} />
        <Route path="/licenses/machinelicenses" element={<MachineLicenses />} />
      </Route>
      <Route path="licensemanager" element={<LicenseManager />} />

      <Route path="/urlforward" element={<UrlForward />} />
      <Route path="/downloads" element={<Downloads />} />

      <Route path="reports">
        <Route path="" element={<Navigate to="reports" replace />} />

        {/* <Route path="licenses" element={<Licenses />} />  */}
        {/* <Route path="urlforward" element={<UrlForward />} />  */}
        <Route path="payments" element={<Payments />} />
        <Route path="downloadsbilling" element={<ReportsDownloadBilling />} />
      </Route>
      <Route path="analytics">
        <Route path="" element={<Navigate to="analytics" replace />} />
        <Route path="emails" element={<EmailHistory />} />
      </Route>

      <Route path="system">
        <Route path="" element={<Navigate to="system" replace />} />

        {/* <Route path="licenses" element={<Licenses />} />  */}
        {/* <Route path="urlforward" element={<UrlForward />} />  */}
        <Route path="coupons" element={<Coupons />} />
        <Route path="products" element={<Products />} />
        <Route path="locale" element={<LocaleStrings />} />
        <Route path="managehoops" element={<ManageHoops />} />
        <Route path="managethreads" element={<ManageThreads />} />
        <Route path="managesupplier" element={<ManageSuppliers />} />
        <Route
          path="managesupplierproducts"
          element={<ManageSupplierProducts />}
        />
        <Route path="managehoops/:hoopId" element={<UpdateHoop />} />
        <Route path="managethreads/:threadId" element={<UpdateThread />} />
      </Route>
      <Route path="tools">
        <Route path="" element={<Navigate to="tools" replace />} />
        <Route path="logs" element={<Logs />} />
        <Route path="summit" element={<Summit />} />
        <Route path="digitizingorder" element={<DigitizingOrdersLogs />} />
      </Route>

      {/* <Route path="managehoops" element={<ManageHoops />} /> */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};
